import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { PERSONAL_DETAILS_UPDATED_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { USER_LOGIN_COUNTRY_ID } from 'apps/auth/constants/Constants';
import { resolveArguments, timer } from 'apps/auth/helpers/utils';
import { useAuth, useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const WelcomePage = (props) => {
    const { showSpecialWelcomeScreen, userName, isNewUser } = useExtra();
    const { countryId, userCountryName } = useAuth();
    const { welcomeMessage, gotIt, specialWelcomeScreenTitle, specialWelcomeScreenText } = usePageMessages();

    useEffect(() => {
        if (isNewUser) {
            amplitude.getInstance().logEvent(PERSONAL_DETAILS_UPDATED_SHOWN);
        }
        let loginCountryId = `${countryId}`;
        const countryCookie = cookies.get(USER_LOGIN_COUNTRY_ID);
        if (countryCookie !== undefined && countryCookie !== null && countryCookie !== 'undefined' && typeof countryCookie === 'string') {
            const countryCookieArr = countryCookie.split(',');
            loginCountryId = countryCookieArr.indexOf(loginCountryId) >= 0 ? `${countryCookie}` : `${countryCookie},${countryId}`;
        }
        cookies.set(USER_LOGIN_COUNTRY_ID, loginCountryId, { path: '/' });
        if (!showSpecialWelcomeScreen) {
            timer(null, props.hideWelcomePage, 2000);
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('prevLoginIso2', userCountryName);
    }, []);

    let infoPageProps;
    if (showSpecialWelcomeScreen) {
        infoPageProps = {
            iconName: 'paysend-logo-globe-circle',
            headerText: specialWelcomeScreenTitle,
            secondaryText: <DangerouslyHtml dangerouslyHtml={specialWelcomeScreenText} />,
            primaryButtonType: 'button',
            primaryButtonCaption: gotIt,
            primaryButtonOnClick: () => {
                props.updateExtraByName('welcomePage', false);
            },
        };
    } else {
        infoPageProps = {
            animatedIconSuccess: true,
            mainText: resolveArguments(welcomeMessage, userName),
        };
    }

    return <InfoPage {...infoPageProps} iconColor="primary" />;
};
WelcomePage.propTypes = {
    hideWelcomePage: PropTypes.func.isRequired,
};
export default connect(null, { updateExtraByName })(WelcomePage);
